import { RootState } from '../store/types';

const createSliceSelector =
	<S>(sliceName: string) =>
	(state: RootState) => {
		if (state[sliceName] === undefined) {
			throw new Error(`Tried selecting state of slice '${sliceName}}' before module was loaded.`);
		}
		return <S>state[sliceName];
	};

export default createSliceSelector;
